import React from "react";
import { Globe, FileCheck, FileText, ShieldCheck } from "lucide-react";

const markets = [
  { code: "UE", label: "Unión Europea" },
  { code: "LATAM", label: "Latinoamérica" },
  { code: "MENA", label: "Oriente Medio y Norte de África" },
  { code: "EE.UU.", label: "Estados Unidos · Registro FDA" },
];

const regulatory = [
  { icon: <FileText className="w-5 h-5" />, title: "Documentación de registro", desc: "Preparación de la documentación técnica necesaria para el registro del producto." },
  { icon: <FileCheck className="w-5 h-5" />, title: "Etiquetado normativo", desc: "Adecuación del etiquetado a la normativa alimentaria nacional y europea." },
  { icon: <ShieldCheck className="w-5 h-5" />, title: "Normativa vigente", desc: "Cumplimiento de la normativa aplicable en cada mercado de destino." },
  { icon: <Globe className="w-5 h-5" />, title: "Soporte de exportación", desc: "Acompañamiento en la exportación a UE, LATAM, MENA y EE.UU." },
];

export default function International() {
  return (
    <section id="internacional" className="relative py-10 md:py-14 bg-[#0A1628] text-white overflow-hidden">
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <div className="hero-blob hero-blob-2" style={{ opacity: 0.3 }} />
      </div>
      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-stretch">
          <div className="lg:col-span-5 flex flex-col">
            <div className="text-xs uppercase tracking-[0.3em] text-[#5DB2F0] font-semibold mb-4">/ 07 · Alcance global</div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-white uppercase tracking-tighter leading-[1]">
              Presencia
              <br />
              <span className="text-[#5DB2F0]">internacional.</span>
            </h2>
            <p className="mt-6 text-slate-300 text-lg">
              Fabricación propia, marca blanca y desarrollo de fórmulas a medida, con vocación de expansión internacional. Nuestro <span className="text-white font-semibold">registro FDA vigente</span> habilita la exportación de complementos alimenticios al mercado estadounidense.
            </p>

            <div className="mt-10 grid grid-cols-2 gap-3 flex-1 auto-rows-fr">
              {markets.map((m, i) => (
                <div key={i} data-testid={`market-${i}`} className="border border-white/15 bg-white/5 rounded-sm p-5 flex flex-col justify-center">
                  <div className="flex items-center gap-2 text-[#5DB2F0] mb-2"><Globe className="w-4 h-4" /></div>
                  <div className="font-display text-xl font-bold text-white">{m.code}</div>
                  <div className="mt-1 text-xs text-slate-400">{m.label}</div>
                </div>
              ))}
            </div>

            <div className="mt-3 border border-[#0A84E2]/40 bg-[#0A84E2]/10 rounded-sm p-5">
              <div className="text-[10px] uppercase tracking-widest text-[#5DB2F0] font-semibold mb-2">Registro FDA (EE.UU.)</div>
              <div className="grid grid-cols-2 gap-3 text-sm">
                <div><span className="text-slate-400">Registro FDA nº</span><br /><span className="text-white font-semibold">17816438408</span></div>
                <div><span className="text-slate-400">DUNS / UFI nº</span><br /><span className="text-white font-semibold">472935474</span></div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col">
            <div className="inline-flex items-center gap-2 text-[#5DB2F0] font-display font-bold text-2xl mb-6">
              <FileCheck className="w-6 h-6" /> Apoyo regulatorio
            </div>
            <p className="text-slate-300 mb-8 max-w-2xl">Ofrecemos apoyo regulatorio en la preparación de la documentación necesaria para el registro, acompañando a cada marca en el cumplimiento de la normativa de sus mercados de destino.</p>

            <div className="grid sm:grid-cols-2 gap-4 flex-1 auto-rows-fr">
              {regulatory.map((a, i) => (
                <div key={i} data-testid={`regulatory-${i}`} className="border border-white/15 bg-white/5 hover:bg-white/10 transition-colors rounded-sm p-6 flex gap-4 h-full items-start">
                  <div className="w-10 h-10 flex-shrink-0 rounded-sm bg-[#0A84E2]/20 border border-[#0A84E2]/40 text-[#5DB2F0] flex items-center justify-center">
                    {a.icon}
                  </div>
                  <div>
                    <h3 className="font-display text-base font-semibold text-white">{a.title}</h3>
                    <p className="mt-1 text-sm text-slate-400 leading-relaxed">{a.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
